export const SET_CURRENT_VENDOR: string = 'SET_CURRENT_VENDOR';
export const SET_CURRENT_SERVICE: string = 'SET_CURRENT_SERVICE';
export const SET_CURRENT_NAMESPACE: string = 'SET_CURRENT_NAMESPACE';
export const GET_GKE_CLUSTERS: string = 'GET_GKE_CLUSTERS';
export const GET_GKE_NAMESPACES: string = 'GET_GKE_NAMESPACES';
export const SET_CURRENT_GKE_TAB: string = 'SET_CURRENT_GKE_TAB';

export const SET_GKE_CLUSTERS = 'setGKEClusters';
export const SET_GKE_NAMESPACES = 'setGKENamespaces';
export const SET_CURRENT_GKE_CLUSTER = 'setCurrentGKECluster';
export const SET_CURRENT_GKE_NAMESPACE = 'setCurrentGKENamespace';
export const SET_CURRENT_GKE_TAB_MUTATION = 'setCurrentGkeTab';
